import { Injectable } from '@angular/core';

import { BehaviorSubject, debounce, of, timer } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class LoadingService {
    private _loading = new BehaviorSubject<boolean>(false);
    public readonly loading$ = this._loading //
        .pipe(debounce((isLoading) => (isLoading ? timer(250) : of(isLoading))));

    public show() {
        this._loading.next(true);
    }

    public hide() {
        this._loading.next(false);
    }
}
